import React, { useCallback, useEffect, useState } from "react";

import Message from "components/Message";

const MessageBoxContext = React.createContext();

const MessageBox = ({ message, unSetMessage }) => {
  return (
    <Message
      onopen={message !== null}
      onclose={() => {
        unSetMessage();
      }}
      type={message.type}
      message={message.message}
    />
  );
};

const MessageBoxProvider = (props) => {
  const [message, showMessage] = useState();
  const [isMessageBoxOpen, setOpen] = useState(true);

  useEffect(() => {
    setOpen(message !== null);
  }, [message]);

  const unSetMessage = useCallback(() => {
    showMessage(null);
  }, [showMessage]);

  return (
    <MessageBoxContext.Provider
      value={{ unSetMessage, showMessage, isMessageBoxOpen }}
      {...props}
    >
      {props.children}
      {message && <MessageBox message={message} unSetMessage={unSetMessage} />}
    </MessageBoxContext.Provider>
  );
};

export { MessageBoxContext, MessageBoxProvider };
